import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

/**
 * Guest-only pages (sign in / sign up). If the user is already logged in, send
 * them back where they came from, or to their profile page.
 */
export default function GuestRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user) {
    const dest = location.state?.from?.pathname || "/profile";
    return <Navigate to={dest} replace />;
  }

  return children;
}
